// @ts-check
/** @typedef {import('../types/api').ShowcaseItem} ShowcaseItem */

import api from '../utils/apiClient';
import { assertArray } from '../utils/apiGuards';

const showcaseService = {
  /**
   * Archived items are excluded unless filters.status is 'archived'.
   * @param {{ kind?: string, status?: string, product_id?: string }} [filters]
   * @returns {Promise<ShowcaseItem[]>}
   */
  list: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.kind) params.append('kind', filters.kind);
    if (filters.status) params.append('status', filters.status);
    if (filters.product_id) params.append('product_id', filters.product_id);
    const query = params.toString();
    const data = await api.get(`/api/admin/showcase${query ? `?${query}` : ''}`);
    assertArray(data, 'showcaseService.list');
    return data;
  },

  /**
   * Always creates a draft; publish with update().
   * @param {Object} payload
   * @returns {Promise<ShowcaseItem>}
   */
  create: (payload) => api.post('/api/admin/showcase', payload),

  /**
   * @param {string} id
   * @param {Object} payload
   * @returns {Promise<ShowcaseItem>}
   */
  update: (id, payload) => api.put(`/api/admin/showcase/${id}`, payload),

  /**
   * @param {string} id
   * @returns {Promise<{ message: string }>}
   */
  archive: (id) => api.post(`/api/admin/showcase/${id}/archive`, {}),

  /**
   * @param {string[]} ids - item ids in their new order
   * @returns {Promise<{ message: string }>}
   */
  reorder: (ids) => api.put('/api/admin/showcase/reorder', { ids }),
};

export default showcaseService;
